import styled from "styled-components";
import React, { Component } from "reactn";
import { getStaticUrl } from "js/config";
import Logos from "js/core/models/logos";
import { getLogoPath } from "common/assetUtils";
import { Thumbnail, ThumbnailContainer } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid";
import { _ } from "js/vendor";
import { IconMenu } from "js/react/components/UiComponents";
import { Icon, MenuItem } from "@material-ui/core";
import { PREDEFINED_PALETTES } from "common/constants";

const ColorChits = styled.div`
  position: absolute;
  bottom: 10px;
  // bottom: ${props => props.offset}px;
  display: flex;
  justify-content: flex-end;
  padding: 0px 10px;
  width: 100%;
`;

const ColorChit = styled.div`
   border-radius: 50%;
   width: 14px;
   height: 14px;
   margin-left: 4px;
`;

const ThumbnailBar = styled.div`
   display: flex;
   align-items: center;
   margin-top: 10px;
   width: 100%;
   label {
    font-size: 14px;
    letter-spacing: 0px;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    flex-grow: 2;
    text-transform: none;
    margin: 0px;
   }
   button {
      padding: 2px;
   }
`;

const LogoImg = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
      position: initial !important;
      width: 70% !important;
      height: 60%;
      object-fit: contain;
  }
`;

const PlaceholderImg = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
      position: initial !important;
      width: 70% !important;
      height: 60%;
      object-fit: contain;
  }
`;

const HiddenSlideBadge = styled.div`
  position:absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  z-index: 100;
  border-radius: 50%;
  background: orangered;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: white;
    font-size: 20px;
  }
`;

export class ThemeThumbnail extends Component {
    lastFetchedLogoPath;

    state = {
        url: null,
        logoURL: null
    }

    componentDidMount() {
        let theme = this.props.item;

        if (theme.get("isBuiltIn")) {
            const url = getStaticUrl(`/builtinThemes/new/${theme.id}.svg`);
            this.setState({ url });
        }

        if (!theme.get("isBuiltIn") && theme.has("logo")) {
            const logoPath = getLogoPath(theme.get("logo"));
            this.lastFetchedLogoPath = logoPath;
            Logos.getSignedUrlAndLoad(logoPath).then(logoUrl => {
                this.setState({ logoUrl });
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const theme = this.props.item;

        if (!theme.get("isBuiltIn") && theme.has("logo")) {
            const logoPath = getLogoPath(theme.get("logo"));
            if (logoPath === this.lastFetchedLogoPath) {
                return;
            }
            this.lastFetchedLogoPath = logoPath;
            Logos.getSignedUrlAndLoad(logoPath).then(logoUrl => {
                this.setState({ logoUrl });
            });
        }
    }

    handleDeleteTheme = () => {
        this.props.onDeleteTheme(this.props.item);
    }

    render() {
        let { item, onClick, onDoubleClick, selected } = this.props;
        let { url, logoUrl } = this.state;

        let palette;
        if (item.get("palette_name") != "custom") {
            let predefinedPalette = _.find(PREDEFINED_PALETTES, { id: item.get("palette_name") || "colorful" });
            if (!predefinedPalette) {
                predefinedPalette = _.find(PREDEFINED_PALETTES, { id: "colorful" });
            }

            palette = predefinedPalette.colors;
        } else {
            palette = item.get("colors");
        }

        let colors = [palette.theme];
        for (let key of Object.keys(palette)) {
            if (key.startsWith("accent")) {
                colors.push(palette[key]);
            }
        }

        const showBar = !item.get("isBuiltIn");
        const menu = this.props.menu;

        return (
            <ThumbnailContainer
                data-item-id={item.id}
                onClick={onClick}
                onDoubleClick={onDoubleClick}
            >

                <Thumbnail
                    selected={selected}
                    url={url}
                    style={{ border: "solid 1px #ccc", boxShadow: "0px 0px 20px rgba(0,0,0,.05)" }}
                    showSpinner={false}
                >
                    {item.get("hidden") && item.has("orgId") && <HiddenSlideBadge><Icon>visibility_off</Icon></HiddenSlideBadge>}
                    {logoUrl && <LogoImg><img src={logoUrl} /></LogoImg>}
                    <ColorChits>
                        {colors.map(color => <ColorChit key={_.uniqueId()} style={{ background: color }} />)}
                    </ColorChits>
                </Thumbnail>

                {showBar && (
                    <ThumbnailBar>
                        <label>{item.get("name")} {/*this.props.isDefault && (
                            <Icon
                                style={{
                                    verticalAlign: "bottom",
                                    paddingLeft: ".2em"
                                }}
                                color="secondary"
                                fontSize="small"
                                title="Default"
                            >check</Icon>
                            )*/}</label>
                        {menu ? menu : (
                            this.props.onDeleteTheme && (
                                <IconMenu>
                                    <MenuItem onClick={this.handleDeleteTheme}><Icon>delete</Icon>Delete Theme...</MenuItem>
                                </IconMenu>
                            )
                        )}
                    </ThumbnailBar>
                )}
            </ThumbnailContainer>
        );
    }
}
